module.exports = __webpack_public_path__ + "img/carro-vermelho.4aa9bc95.png";